export const GET_ALL_DECKS = 'GET_ALL_DECKS';
export const LOADING = 'LOADING';
export const GET_DECKS_BY_USER = 'GET_DECKS_BY_USERID';
export const GET_DECKS_PAGINATION = 'GET_DECKS_PAGINATION';
export const GET_PROGRESS_DECKS_BY_USER = 'GET_PROGRESS_DECKS_BY_USER';
export const GET_DECKS_CATEGORY = 'GET_DECKS_CATEGORY';
export const GET_DECK_BY_ID = 'GET_DECK_BY_ID';
export const CREATE_DECK = 'CREATE_DECK';
export const CREATE_CARD = 'CREATE_CARD';
export const GET_CARDS_BY_DECKID = 'GET_CARDS_BY_DECKID';
export const GET_PRATICE = 'GET_PRATICE';
export const GET_NEED_TO_RECALL = 'GET_NEED_TO_RECALL';
export const GET_MASTERED = 'GET_MASTERED';
export const CARDS_AMOUNT = 'CARDS_AMOUNT';
export const CARDS_AMOUNT_NEED_TO_RECALL = 'CARDS_AMOUNT_NEED_TO_RECALL';
export const CARDS_AMOUNT_NEED_TO_STUDY = 'CARDS_AMOUNT_NEED_TO_STUDY';
export const CARDS_AMOUNT_MASTERED = 'CARDS_AMOUNT_MASTERED';
export const SWIPE_LEFT = 'SWIPE_LEFT';
export const SWIPE_RIGHT = 'SWIPE_RIGHT';
export const EDIT_DECK = 'EDIT_DECK';
export const GET_DATA_EDIT = 'GET_DATA_EDIT';
export const SET_TEST_QUIZ = 'SET_TEST_QUIZ';
export const SET_TEST_DECKID = 'SET_TEST_DECKID';
export const TAKE_TEST_MULTIPLE = 'TAKE_TEST_MULTIPLE';
export const TAKE_TEST_TRUE_FALSE = 'TAKE_TEST_TRUE_FALSE';
export const GET_RESULT_TEST = 'GET_RESULT_TEST';
export const FINISHED = 'FINISHED';
